import { getAuthCode } from "./getAuthCode";
export const fetchScheduledPosts = async (setScheduledPosts) => {
    try {
      let url = process.env.REACT_APP_BACKEND_URL + "/retrieveScheduledPosts";
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body:JSON.stringify({auth_code:await getAuthCode()})
      });
      const result = await response.json();
      setScheduledPosts(result);
      return result
    } catch (error) {
      console.log(error);
    }
  };